const data = {
  "energyLabel": {
    "modalTitle": "Energielabel {{rating}}",
    "productSpecificationLink": "Productinformatieblad"
  }
};

export default data;